module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-content"
  }, [(_vm.activeTab === 'packageDown') ? [_c('packageDown', {
    attrs: {
      "item": _vm.versionData,
      "type": _vm.curTabVersion,
      "active-tab": _vm.activeTab
    },
    on: {
      "recordUserDownload": _vm.recordUserDownload,
      "containerDeployValidate": _vm.containerDeployValidate
    }
  })] : [_c('versionList', {
    attrs: {
      "item": _vm.versionData,
      "type": _vm.curTabVersion
    },
    on: {
      "recordUserDownload": _vm.recordUserDownload,
      "containerDeployValidate": _vm.containerDeployValidate
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-12c467e1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/downloadContent.vue
// module id = xxip
// module chunks = 15